import { useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';
import ReactJson from '@microlink/react-json-view';
import { getJsonViewTheme } from './jsonViewTheme.ts';
import { FONT_MONO } from 'themes/tokens';

type Props = {
  src: object;
  name?: string;
};
export const JsonView = ({ src, name }: PropsWithChildren<Props>) => {
  const theme = useTheme();

  return (
    <ReactJson
      src={src}
      name={name}
      displayDataTypes={false}
      displayObjectSize={false}
      enableClipboard={false}
      theme={getJsonViewTheme(theme.palette.mode)}
      style={{ padding: 12, borderRadius: 8, fontFamily: FONT_MONO }}
    />
  );
};
